import { render, staticRenderFns } from "./richtext.vue?vue&type=template&id=06a2298b&"
import script from "./richtext.vue?vue&type=script&lang=js&"
export * from "./richtext.vue?vue&type=script&lang=js&"
import style0 from "./richtext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports